<template>
  <div class="bs-sysMsg" v-if="systemMsg.length > 0">
    <div class="msg__content">
      <el-carousel height="20px" direction="vertical" indicator-position="none" :autoplay="true">
        <el-carousel-item v-for="item in systemMsg" :key="item.id">
          <a href="javascript:void(0)"  @click="go(item)" class="item">{{item.title}}</a>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>
<script>
export default {
  props: ['items'],
  data(){
    return{
      // 滚屏消息
      systemMsg:this.items|| [
        {id:1,title:'入主白宫近10日 拜登做了10件大事'},
        {id:2,title:'全民带货？小红书外链淘宝权限将大范围开放'},
        {id:3,title:'贾跃亭FF将在纳斯达克上市 股票代码为FFIE'}
      ],
    }
  },

  methods: {
    go(item){
      this.$emit('go', item);
    }
  },
}

</script>
<style scoped lang="scss">
/*轮翻消息*/
.bs-sysMsg {
  position: relative;
  display: flex;
  width: 100%;
  padding: 8px 0px;
  margin-bottom: 10px;
  border-radius: 2px;
  color: #e6a23c;
  overflow: hidden;
  align-items: center;
  transition: opacity .2s;
}
.bs-sysMsg .msg__content {
  display: table-cell;
  padding: 0 4px;
  width: 100%;
  text-align: left;
}
.bs-sysMsg .msg__content a.item {
  color: #eeeeee;
  font-size: 14px;
}
.bs-sysMsg .msg__content a.item:hover{text-decoration: underline;}
</style>